import axios from 'axios';

let testUrl = 'https://zg.lifejiankang.com/api'; // 生产地址
//let testUrl = 'http://localhost:8080/healthy'; // 开发地址
let lifeJkAppId= "lifejk_appId";
let lifeJkToken = "life_token_";
let jxLifeAppId = "wx1b496ca6f2542564";
export var base = testUrl;
export var AppIdName = lifeJkAppId;
export var TokenName = lifeJkToken;
export var jxAppId = jxLifeAppId;



axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
//添加请求拦截器
axios.interceptors.request.use(function (config) {
  let appId = localStorage.getItem(AppIdName)
  let token = localStorage.getItem(TokenName+appId)  
  if (config.data) {
    config.data = /token/g.test(config.data) ? config.data : config.data + '&token=' + token;
  } else if (config.params) {
    config.params['token'] = token;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});